import React, { useMemo, useState, useEffect } from "react";
import ScrollList from "../other/scrollList";
import Checkbox from "./Checkbox";
import Button from "./Button";
import Input from "./Input";

export default function MultiSelectMenu({
  closeState,
  setCloseState,
  hasSearch = true,
  items,
  setValue,
  getValues,
  name,
  watch,
  ...props
}) {
  const applyButtonContent = "Применить";

  const [searchString, setSearchString] = useState("");

  const checkedBoxes = watch(name) || {};

  const handleOptionToggle = (optionName) => {
    const currentValues = getValues(name) || {};
    setValue(
      name,
      {
        ...currentValues,
        [optionName]: !currentValues[optionName],
      },
      { shouldValidate: true }
    );
  };

  const boxes = useMemo(() => {
    const boxes = items?.map((value, index) => {
      const isShowing = value.name
        .toLowerCase()
        .includes(searchString.toLocaleLowerCase());
      const showStyle = isShowing ? null : { display: "none" };
      const isChecked = !!checkedBoxes[value.id];
      return (
        <Checkbox
          style={showStyle}
          labelStyle={showStyle}
          label={value.name}
          key={index}
          name={name}
          value={value.id}
          id={name + "." + value.id}
          checked={isChecked}
          onChange={() => handleOptionToggle(value.id)}
        />
      );
    });

    return boxes;
  }, [items, searchString, checkedBoxes, watch]);

  // useEffect(() => {
  //     return () => { console.log('hidden') }
  // })

  function close() {
    setCloseState(true);
  }

  function apply() {
    setCloseState(true);
  }

  function reset() {
    setValue(name, {}, { shouldValidate: true });
  }

  const search = hasSearch ? (
    <Input
      placeholder="Поиск"
      value={searchString}
      onChange={(evt) => setSearchString(evt.target.value)}
    />
  ) : null;

  return (
    <div className="multiSelect-menu" closed={"" + closeState} {...props}>
      <div className="multiSelect-menu-title">
        <p className="multiSelect-menu-title-text">{props.title}</p>
        <Button className="multiSelect-menu-closeButton" refStyle>
          <img src="/UI/closeIcon.svg" alt="Закрыть" onClick={close} />
        </Button>
      </div>

      {search}

      <ScrollList className="multiSelect-menu-scrollList">{boxes}</ScrollList>
      <div className="multiSelect-menu-buttons">
        <Button
          className="multiSelect-menu-button multiSelect-menu-button-reset"
          darkStyle
          type="submit"
          onClick={() => reset()}
        >
          Сбросить
        </Button>
        <Button
          className="multiSelect-menu-button multiSelect-menu-button-apply"
          contrastStyle
          type="submit"
          onClick={() => apply()}
        >
          {applyButtonContent}
        </Button>
      </div>
    </div>
  );
}
